import axios from 'axios';
import notifyConfigure from 'components/Toast';
import { checkStatus } from './checkStatus';
import { getBaseURL } from './getBaseURL';
import dataLayer from './dataLayer';

const baseURLAPIS = getBaseURL().base;

let initialToastfy = {
	error: false,
	success: false,
	warning: false,
};
let cacheStatus = null;
export default class HttpClient {
	constructor() {
		this.client = axios.create({
			baseURL: baseURLAPIS,
			headers: {
				'Content-Type': 'application/json',
			},
			timeout: 50000,
		});
	}

	get(url, config = null, isToastfy = initialToastfy) {
		return this.client.get(url, config).then((res) => {
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}

	post(url, params, config, isToastfy = initialToastfy) {
		return this.client
			.post(url, params, config)
			.then((res) => {
				if (cacheStatus === null && res?.data?.Status === 462) {
					checkStatus(res?.data?.Status);
					cacheStatus = res?.data?.Status;
					sessionStorage.removeItem('show_wallets');
				}

				// if (!res?.data?.Success && isToastfy?.error === true) {
				// 	notifyConfigure(res?.data?.Status, res?.data?.Success, res?.data?.Message, {
				// 		error: true,
				// 		success: false,
				// 	});
				// 	return res;
				// }

				const messages = res?.data?.Message || res?.data?.Content;
				notifyConfigure(res?.data?.Status, res?.data?.Success, messages, isToastfy);

				return res;
			})
			.catch((error) => {
				dataLayer({
					'event_name': 'Snackbar_Error',
					'event_category': 'Error',
					'event_action': 'General',
					'event_label': error?.response?.data?.Message || 'خطا در بر قراری سرور',
					'event_value': null,
				});

				return notifyConfigure(400, false, error?.response?.data?.Message || 'خطا در ارتباط با سرور', {
					error: true,
					success: false,
				});
			});
	}

	delete(url, config = null, isToastfy = initialToastfy) {
		return this.client.delete(url, config).then((res) => {
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}
	put(url, params, config = null, isToastfy = initialToastfy) {
		return this.client.put(url, params, config).then((res) => {
			notifyConfigure(res?.data?.Status, res?.data?.Success, res.data?.Message, isToastfy);

			return res;
		});
	}
}
